import React, { useState, useEffect } from 'react';
import { Grid, Typography, Link, Divider } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import careerClasses from './careersStyles'

function CareersSpotlight() {
  const globalClasses = globalUseStyles();
  const careerStyles = careerClasses();
  const [isShownHoverContent, setIsShownHoverContent] = useState(false);
  const [isShownContent, setIsShownContent] = useState(true);
  const [hovered, setHovered] = useState(true);

  useEffect(() => {
    //preloading image
      const img = new Image();
      img.src = '../../img/employee-spot-hover.jpg';
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Container className={"careersSpotlightStyle"} maxWidth={false} component="section">
        <Grid className={globalClasses.containerBottomPadding} container>
          <Grid className={globalClasses.containerSmall} container >
            <Grid item xs={12} md={12}  >
              <Typography variant="subtitle1">Employee Spotlight</Typography>
              <Typography variant="h2">Meet Jennifer</Typography>
            </Grid>
            <Grid item xs={12} md={12} container>
              <Grid item xs={12} md={4}>
                <Grid 
                    onMouseEnter={() => {setIsShownHoverContent(true); setIsShownContent(false); setHovered(false); }}
                    onMouseLeave={() => {setIsShownHoverContent(false); setIsShownContent(true); setHovered(true)}}
                    className={hovered ? 'career-bio'  : 'career-bio2' }
                    item xs={12} md={12}/>
                    <Grid item xs={12}>
                      <Typography align="center" className={careerStyles.namePadding} variant="h4">Jennifer Yoda, Web Developer</Typography>
                      <Typography variant="body1" >
                        {/*<Link href='https://www.linkedin.com' className={globalClasses.linkStyleArrowCentered} color="primary" component={RouterLink}>
                        View LinkedIn Profile <ArrowForwardIcon className={globalClasses.arrowForward}/></Link>*/}
                        <Link color="primary" className={"link link--arrowed centered"} href='https://www.linkedin.com'>View LinkedIn Profile
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                        </Link>
                    </Typography>

                    </Grid>
              </Grid>
              <Grid className={globalClasses.textBlock} item xs={12} md={8} container >
              {isShownHoverContent && (
                <div>
              
                <Container maxWidth={false} style={{padding:0}}>
                 <Grid item xs={12} md={12} container >
                  <Grid item xs={12} md={6} className={careerStyles.careerBoxes} >
                <Typography  variant="h4">Favorite Movie</Typography>
                <Divider className={careerStyles.dividerSpotlight}/>
                <Typography  variant="body2">Star Wars</Typography>
                </Grid>
                <Grid item xs={12} md={6} className={careerStyles.careerBoxes} >
                <Typography  variant="h4">Favorite Food</Typography>
                <Divider className={careerStyles.dividerSpotlight}/>
                <Typography  variant="body2">Rootleaf Stew</Typography>
                </Grid>
                 <Grid item xs={12} md={6} className={careerStyles.careerBoxes} >
                <Typography  variant="h4">Eye Color</Typography>
                <Divider className={careerStyles.dividerSpotlight}/>
                <Typography  variant="body2">Green</Typography>
                </Grid>
                <Grid item xs={12} md={6} className={careerStyles.careerBoxes} >
                <Typography  variant="h4">Favorite Sport</Typography>
                <Divider className={careerStyles.dividerSpotlight}/>
                <Typography  variant="body2">Hockey</Typography>
                </Grid>
                 <Grid item xs={12} md={6} className={careerStyles.careerBoxes} >
                <Typography  variant="h4">Favorite Quote</Typography>
                <Divider className={careerStyles.dividerSpotlight}/>
                <Typography  variant="body2">"You must unlearn what you have learned"</Typography>
                </Grid>
                 <Grid item xs={12} md={6} className={careerStyles.careerBoxes} >
                <Typography  variant="h4">Fun Fact</Typography>
                <Divider className={careerStyles.dividerSpotlight}/>
                <Typography  variant="body2">Jennifer is a master of lightsaber combat</Typography>
                </Grid>
                 </Grid>
              </Container>
                </div>
              )}
             {isShownContent && (

                <div>
                <Grid item xs={12} md={12} container>
                <Grid item xs={12} className={careerStyles.careerMargin}>
                <Typography variant="h4">Time at Pantheon</Typography>
                <Divider className={careerStyles.dividerSpotlight}/>
                <Typography variant="body1">5 years</Typography>
                </Grid>
                <Grid item xs={12} className={careerStyles.careerMargin}>
                <Typography variant="h4">What's it like to work at Pantheon?</Typography>
                <Divider className={careerStyles.dividerSpotlight}/>
                <Typography variant="body1">"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident."</Typography>
                </Grid>
                <Grid item xs={12} className={careerStyles.careerMargin}>
                <Typography variant="h4">What's your favorite project?</Typography>
                <Divider className={careerStyles.dividerSpotlight}/>
                <Typography variant="body1">"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. "</Typography>
                </Grid>
                </Grid>
                </div>
             )}
              </Grid>         
            </Grid>
          </Grid>
        </Grid>  
        
      </Container>
    </ThemeProvider>
  );
};

export default CareersSpotlight;